import { render, staticRenderFns } from "./SiblingElement.vue?vue&type=template&id=5791016a"
import script from "./SiblingElement.vue?vue&type=script&lang=js"
export * from "./SiblingElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports